export default `cube.xyz -= pos;
  return max(max(abs(cube.x)-cube.w,abs(cube.y)-cube.w),abs(cube.z)-cube.w);
}

int m; 
float df(vec3 p){
  float t = time; 
  p += vec3(
    sin(p.z * 1.55 + t) + sin(p.z * 1.34 + t),
    0.,
    sin(p.x * 1.34 + t) + sin(p.x * 1.55 + t)
  ) * .5;
  vec3 mp = mod(p, 1.);
  mp.y = p.y;
  
  float s1 = cube(
    vec4(0.5, 0.5, 0.5, 0.15),
    vec3(mp.x, mp.y + (sin(p.z * PI) * sin(p.x * PI)) * 0.25, 0.5));
  float s2 = cube(
    vec4(0.5, 0.5, 0.5, 0.15), 
    vec3(0.5, mp.y + (sin(p.x * PI) * -sin(p.z * PI)) * 0.25, mp.z));
  m = s1 < s2 ? 0 : 1;
  return min(s1, s2);
}`